export default (state = [], action) => {
  switch (action.type) {
    case 'REQUEST_WITHDRAWALS':
      return {
        ...state,
        failureFetching: false,
        isFetching: true,
      };
    case 'RECEIVE_WITHDRAWALS':
      return {
        ...state,
        failureFetching: false,
        isFetching: false,
        isFetched: true,

        items: action.receivedData,
      };
    default:
      return state;
  }
};
